(() => {
  const init = (root) => {
    if (!root || root.dataset.wh20Bound === 'true') return;
    root.dataset.wh20Bound = 'true';

    const search = root.querySelector('[data-wh20-category-search]');
    const clear = root.querySelector('[data-wh20-category-clear]');
    const reset = root.querySelector('[data-wh20-category-reset]');
    const empty = root.querySelector('[data-wh20-category-empty]');
    const count = root.querySelector('[data-wh20-visible-count]');
    const cards = [...root.querySelectorAll('[data-wh20-category-card]')];
    const filters = [...root.querySelectorAll('[data-wh20-category-filter]')];
    let group = 'all';

    const apply = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const title = card.dataset.title || '';
        const cardGroup = card.dataset.group || 'lifestyle';
        const matchesQuery = !query || title.includes(query);
        const matchesGroup = group === 'all' || cardGroup === group;
        const show = matchesQuery && matchesGroup;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
      if (clear) clear.hidden = !query;
    };

    search?.addEventListener('input', apply);
    clear?.addEventListener('click', () => {
      search.value = '';
      search.focus();
      apply();
    });

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        group = button.dataset.wh20CategoryFilter || 'all';
        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        apply();
      });
    });

    reset?.addEventListener('click', () => {
      group = 'all';
      if (search) search.value = '';
      filters.forEach((item) => {
        const active = item.dataset.wh20CategoryFilter === 'all';
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      apply();
    });

    apply();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-wh20-categories]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
